import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentExam } from "store/ExamStore/selectors";
import ReactPlayer from "react-player";
import { selectRequests } from "../../../store/LoadingStore/selectors";
import { Requests } from "../../../types/requests";
import { Button } from "components/Buttons/Button";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { getData } from "../../../contexts/authContext";
import { Grid, CircularProgress } from "@mui/material";
import { icons } from "constants/icons";
import { useSelector } from "react-redux";
import { selectCurrentExamMLResult } from "../../../store/ExamMLResultStore/selectors";
export const VideoComponent = () => {
  const exam = useAppSelector(selectCurrentExam);
  const examMLResult = useSelector(selectCurrentExamMLResult);
  const [internalLoading, setInternalLoading] = useState<boolean>(true);
  const [skeletalLayer, setSkeletalLayer] = useState<boolean>(false);
  const [anglesCalculationsLayer, setAnglesCalculationsLayer] =
    useState<boolean>(false);

  const loading = useAppSelector((state: any) =>
    selectRequests([Requests.getExam], state)
  );
  const [originalLayerVideoRef, setOriginalLayer] =
    useState<ReactPlayer | null>();
  const [skeletalLayerVideoRef, setSkeletalLayerVideoRef] =
    useState<ReactPlayer | null>();
  const [anglesCalculationsLayerVideoRef, setAnglesCalculationsLayerVideoRef] =
    useState<ReactPlayer | null>();
  const [allLayersVideoRef, setAllLayersVideoRef] =
    useState<ReactPlayer | null>();

  const [originalVideo, setOriginalVideo] = useState<any | null>();
  const [skeletalVideo, setSkeletalVideo] = useState<any | null>();
  const [anglesCalculationsVideo, setAnglesCalculationsVideo] = useState<
    any | null
  >();
  const [allLayersVideo, setAllLayersVideo] = useState<any | null>();

  const handleDownloadVideo = async () => {
    try {
      if (originalVideo) {
        const videoUrl = originalVideo;
        const videoRequest = new Request(videoUrl);
        fetch(videoUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.blob();
          })
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "athleteDetail.mp4");
            document.body.appendChild(link);

            link.click();

            // Ensure link is removed after a short delay to allow the download to start
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url); // Clean up the object URL
            }, 100);
          })
          .catch((error) => {
            console.error(
              "There has been a problem with your fetch operation:",
              error
            );
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resetVideoPlayers = () => {
    setOriginalVideo(null);
    setOriginalLayer(null);
    setAnglesCalculationsVideo(null);
    setAnglesCalculationsLayerVideoRef(null);
    setSkeletalVideo(null);
    setSkeletalLayerVideoRef(null);
    setAllLayersVideo(null);
    setAllLayersVideoRef(null);
  };

  useEffect(() => {
    if (
      originalLayerVideoRef &&
      skeletalLayerVideoRef &&
      anglesCalculationsLayerVideoRef
    ) {
      if (skeletalLayer && !anglesCalculationsLayer) {
        skeletalLayerVideoRef.seekTo(0, "seconds");
      }
      if (anglesCalculationsLayer && !skeletalLayer) {
        anglesCalculationsLayerVideoRef.seekTo(0, "seconds");
      }
      if (anglesCalculationsLayer && skeletalLayer) {
        // @ts-ignore: Unreachable code error
        allLayersVideoRef.seekTo(0, "seconds");
      }
      if (!anglesCalculationsLayer && !skeletalLayer) {
        originalLayerVideoRef.seekTo(0, "seconds");
      }
    }
  }, [skeletalLayer, allLayersVideoRef, anglesCalculationsLayer]);

  useEffect(() => {
    const fetchData = async () => {
      if (exam._id) {
        setInternalLoading(true);
        resetVideoPlayers();
        await Promise.all([
          getVideoFromUrl(
            `${process.env.REACT_APP_EXAM_VIDEO_S3_URL}/unprocessed/${exam.patientId}/${exam._id}.mp4`,
            setOriginalVideo
          ),
          getVideoFromUrl(
            `${process.env.REACT_APP_EXAM_VIDEO_S3_URL}/processed/${exam.patientId}/${exam._id}-angles.mp4`,
            setAnglesCalculationsVideo
          ),
          getVideoFromUrl(
            `${process.env.REACT_APP_EXAM_VIDEO_S3_URL}/processed/${exam.patientId}/${exam._id}-skeleton.mp4`,
            setSkeletalVideo
          ),
          getVideoFromUrl(
            `${process.env.REACT_APP_EXAM_VIDEO_S3_URL}/processed/${exam.patientId}/${exam._id}.mp4`,
            setAllLayersVideo
          ),
        ]);

        setTimeout(() => {
          setInternalLoading(false);
        }, 10000);
      }
    };
    fetchData();
  }, [exam]);

  async function getVideoFromUrl(url: string, setVideo: any) {
    try {
      const token = await getData("idToken");
      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          setVideo(URL.createObjectURL(blob));
        });
    } catch (err) {
      console.log(err);
    }
  }
  const getVideoUrl = () => {
    if (!examMLResult.result) {
      return originalVideo;
    }

    if (!skeletalLayer && !anglesCalculationsLayer) {
      return originalVideo;
    }

    if (skeletalLayer && anglesCalculationsLayer) {
      return allLayersVideo;
    }

    if (skeletalLayer && !anglesCalculationsLayer) {
      return skeletalVideo;
    }

    if (!skeletalLayer && anglesCalculationsLayer) {
      return anglesCalculationsVideo;
    }
  };

  const setVideoRef = (rp: ReactPlayer | null) => {
    if (!skeletalLayer && !anglesCalculationsLayer) {
      setOriginalLayer(rp);
      return () => {};
    }

    if (skeletalLayer && anglesCalculationsLayer) {
      setAllLayersVideoRef(rp);
      return () => {};
    }

    if (skeletalLayer && !anglesCalculationsLayer) {
      setSkeletalLayerVideoRef(rp);
      return () => {};
    }

    if (!skeletalLayer && anglesCalculationsLayer) {
      setAnglesCalculationsLayerVideoRef(rp);
      return () => {};
    }
  };
  return (
    <>
      {loading || (internalLoading && false) ? (
        <>
          <Skeleton width={268} height={580} />
        </>
      ) : (
        <div className="items-center">
          <div className="absolute top-5 left-7 z-50">
            <Button
              title="Skeletal"
              onClick={() => setSkeletalLayer(!skeletalLayer)}
              type={ButtonType.small}
              classNames="self-center"
              colorScheme={
                !skeletalLayer
                  ? ButtonColorScheme.default
                  : ButtonColorScheme.accent
              }
            />
            <Button
              title="Angle"
              onClick={() =>
                setAnglesCalculationsLayer(!anglesCalculationsLayer)
              }
              type={ButtonType.small}
              classNames="self-center ml-24"
              colorScheme={
                !anglesCalculationsLayer
                  ? ButtonColorScheme.default
                  : ButtonColorScheme.accent
              }
            />
          </div>

          {internalLoading ? (
            <div
              style={{
                height: "300px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <ReactPlayer
              url={getVideoUrl()}
              className="player"
              width="100%"
              height="auto"
              controls={true}
              playing={true}
              ref={setVideoRef}
              onReady={(reactVideo) =>
                (reactVideo.getInternalPlayer().style.borderRadius = "30px")
              }
              style={{
                visibility: "visible",
                borderRadius: "30px",
              }}
            />
          )}

          <Grid xs={12} display="flex" justifyContent="center" mt={5}>
            <Button
              title="Download"
              onClick={handleDownloadVideo}
              iconPath={icons.download}
              type={ButtonType.normal}
              style={{
                fontSize: "18px",
                fontWeight: "400",
                backgroundColor: "#FFFFFF",
                color: "#5C5D68",
                borderRadius: 10,
                boxShadow: "0 10px 10px rgba(0, 0, 0, 0.1)",
              }}
            />
          </Grid>
        </div>
      )}
    </>
  );
};
